import {Component} from "@angular/core";
import {TipoPreguntaComponent} from "../tipo-pregunta/tipo-pregunta.component";


@Component({
    selector: "app-tipo-pregunta-vacio",
    templateUrl: "./tipo-pregunta-vacio.component.html",
    styleUrls: ["./tipo-pregunta-vacio.component.scss"]
})
export class TipoPreguntaVacioComponent extends TipoPreguntaComponent {

}
